import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { LocatiiServiciiService } from '../locatii-servicii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { LocatieServiciiActive, LocatieServiciiActiveUpdate } from '../locatii-servicii.interface';
import { LocatiiService } from '../../locatii/locatii.service';
import { ServiciiService } from '../../servicii/servicii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';

@Component({
    selector: 'app-edit-locatii-servicii',
    templateUrl: './edit-locatii-servicii.component.html',
    styleUrls: ['./edit-locatii-servicii.component.scss']
})
export class EditLocatiiServiciiComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    locatii!: any[];
    servicii!: any[];

    form: FormGroup = new FormGroup({
        id_locatie: new FormControl(this.data.id_locatie, [Validators.required, notDefaultValidator('-1')]),
        id_serviciu: new FormControl(this.data.id_serviciu, [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditLocatiiServiciiComponent>,
        private locatiiServiciiActiveService: LocatiiServiciiService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private locatiiService: LocatiiService,
        private serviciiService: ServiciiService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadLocatii();
        this.loadServicii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.locatiiServiciiActiveService.setToken(token);
        });
    }

    loadLocatii() {
        this.isLoading = true;
        this.locatiiService.getLocatii().pipe(
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.locatii = res;
            },
            error: (err) => {
                console.error('Error in get locatii: ', err);
            }
        })
    }

    loadServicii() {
        this.isLoading = true;
        this.serviciiService.getServicii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.servicii = res;
            },
            error: (err) => {
                console.error('Error in get servicii: ', err);
            }
        })
    }

    submitForm() {
        this.isLoading = true;

        const { id_locatie, id_serviciu } = this.form.value as LocatieServiciiActive;

        const updatedLocatieServiciiActive: LocatieServiciiActiveUpdate = {
            id_locatie,
            id_serviciu,
            id: this.data.id,
        };

        this.locatiiServiciiActiveService
            .updateLocatieServicii(updatedLocatieServiciiActive)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
